import { STATUS_CLASSES } from '../../interfaces/interoperability.interfaces';
import { SELECT_ESTATUS_SERVICE } from '../../interfaces/services.interface';
import Select from 'react-select';

function StatusSelect({ value, onChange }) {
  const normalizedValue = value?.toUpperCase();
  const statusStyle = STATUS_CLASSES[normalizedValue] || STATUS_CLASSES.DESCONECTADO;
  const selectedOption = SELECT_ESTATUS_SERVICE.find(
    (option) =>
      option.value.toUpperCase() === normalizedValue ||
      option.key.toUpperCase() === normalizedValue
  );

  return (
   
    <Select
      options={SELECT_ESTATUS_SERVICE}
      getOptionLabel={(option) => option.value}
      getOptionValue={(option) => option.key}
      value={selectedOption || null}
      onChange={(option) => {
        if (option) onChange(option.value);
      }}
      placeholder="Elige una opción"
      isSearchable={false}
      classNamePrefix="select"
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: statusStyle.backgroundColor,
          borderColor: 'transparent',
          boxShadow: 'none',
          cursor: 'pointer',
          fontWeight: 600,
          minHeight: '2rem',
          ':hover': { borderColor: 'transparent' },
        }),
        singleValue: (base) => ({ ...base, color: statusStyle.color }),
        option: (base, state) => {
          const optionStyle =
            STATUS_CLASSES[state.data.value.toUpperCase()] || STATUS_CLASSES.DESCONECTADO;
          return {
            ...base,
            backgroundColor: state.isFocused
              ? optionStyle.backgroundColor
              : 'var(--color-surface)',
            color: optionStyle.color,
            cursor: 'pointer',
          };
        },
      }}
    />
  );
}
export default StatusSelect;
